import { createSlice } from "@reduxjs/toolkit";

const announcementSlice = createSlice({
  name: "announcement",
  initialState: {
    refreshFlag: 0
  },
  reducers: {
    refreshAnnouncement(state) {
      state.refreshFlag++;  // Trigger hook refresh
    }
  }
});

export const { refreshAnnouncement } = announcementSlice.actions;
export default announcementSlice.reducer;
